import { render, staticRenderFns } from "./guide_record_cehckin_process.vue?vue&type=template&id=2f123362&scoped=true&lang=pug&"
var script = {}
import style0 from "./guide_record_cehckin_process.vue?vue&type=style&index=0&id=2f123362&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f123362",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f123362')) {
      api.createRecord('2f123362', component.options)
    } else {
      api.reload('2f123362', component.options)
    }
    module.hot.accept("./guide_record_cehckin_process.vue?vue&type=template&id=2f123362&scoped=true&lang=pug&", function () {
      api.rerender('2f123362', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/info/guide_record_cehckin_process.vue"
export default component.exports